export class ClassDxLookup {
    public DataSource: any = null;
    public DisplayExpr: string = "";
    public ValueExpr: string = "";

}